import React, { useState } from 'react';
import { useParams } from 'react-router-dom'; // Import useParams
import ConversationalForm from './ConversationalForm';
import BookingSummary from './BookingSummary';
import ProgressBar from './ProgressBar';
import './BookingPage.css';

function BookingPage() {
  const { sedeId } = useParams(); // Get sedeId from URL
  const [bookingData, setBookingData] = useState({
    sede: null,
    date: null,
    time: null,
    people: null,
    name: '',
    email: '',
    phone: '',
  });
  const [currentStep, setCurrentStep] = useState(0);
  const steps = ['Sede', 'Fecha', 'Hora', 'Personas', 'Datos', 'Confirmar'];

  const handleDataChange = (newData) => {
    setBookingData(prevData => ({ ...prevData, ...newData }));
  };

  const handleStepChange = (step) => {
    setCurrentStep(step);
  };

  const handleReservationSuccess = () => {
    // Reset booking data and step to effectively close the form
    setBookingData({
      sede: null,
      date: null,
      time: null,
      people: null,
      name: '',
      email: '',
      phone: '',
    });
    setCurrentStep(0);
  };

  return (
    <div className="booking-page">
      <ProgressBar steps={steps} currentStep={currentStep} />
      <div className="booking-content">
        <div className="booking-form-container">
          <ConversationalForm 
            bookingData={bookingData}
            onDataChange={handleDataChange} 
            currentStep={currentStep}
            onStepChange={handleStepChange}
            initialSede={sedeId} // Pass sedeId
            onReservationSuccess={handleReservationSuccess} // Pass success handler
          />
        </div>
        <div className="booking-summary-container">
          <BookingSummary data={bookingData} />
        </div>
      </div>
    </div>
  );
}

export default BookingPage;